import React from 'react';
import { useDispatch } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';
import { Button, Divider } from 'components/ui';
import Markdown from 'components/Markdown/Markdown';
import localeUtils from 'utils/LanguageLocale';
import Actions from 'actions/Actions';
import Empty from 'constants/empty';
import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import GuestCheckoutJoinBIEN from 'components/RichProfile/MyAccount/OrderDetail/GuestCheckoutJoinBI/locales/GuestCheckoutJoinBI_en_US.js';
import GuestCheckoutJoinBIFR from 'components/RichProfile/MyAccount/OrderDetail/GuestCheckoutJoinBI/locales/GuestCheckoutJoinBI_fr_CA.js';

const getText = localeUtils.getLocalisedDataFromResource(GuestCheckoutJoinBIEN, GuestCheckoutJoinBIFR);

const GUEST_CHECKOUT_OD_ACTION_INFO = {
    bopis: {
        signIn: anaConsts.LinkData.GUEST_CHECKOUT_OD_SIGN_IN_BOPIS,
        createAccount: anaConsts.LinkData.GUEST_CHECKOUT_OD_CREATE_ACCOUNT_BOPIS
    },
    sdd: {
        signIn: anaConsts.LinkData.GUEST_CHECKOUT_OD_SIGN_IN_SDD,
        createAccount: anaConsts.LinkData.GUEST_CHECKOUT_OD_CREATE_ACCOUNT_SDD
    },
    mixed: {
        signIn: anaConsts.LinkData.GUEST_CHECKOUT_OD_SIGN_IN_MIXED,
        createAccount: anaConsts.LinkData.GUEST_CHECKOUT_OD_CREATE_ACCOUNT_MIXED
    }
};

const GuestCheckoutJoinBI = props => {
    const {
        orderId, points = 0, guestProfile = Empty.Object, firstName = '', lastName = '', fulfillmentType
    } = props;
    const dispatch = useDispatch();
    const email = guestProfile.email;
    const isEmailRegistered = guestProfile.isEmailRegistered || false;
    const isStoreBIMember = guestProfile.isStoreBIMember || false;

    const fireCtaLinkTracking = () => {
        const actionInfo = GUEST_CHECKOUT_OD_ACTION_INFO[fulfillmentType]?.[isEmailRegistered ? 'signIn' : 'createAccount'];

        if (actionInfo) {
            processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
                data: {
                    actionInfo,
                    linkName: actionInfo
                }
            });
        }
    };

    const handleCreateAccount = () => {
        dispatch(
            Actions.showRegisterModal({
                isOpen: true,
                userEmail: email,
                isEmailDisabled: true,
                skipEmailLookup: true,
                biData: {
                    firstName,
                    lastName
                },
                isStoreUser: isStoreBIMember
            })
        );
    };

    const handleSignIn = () => {
        dispatch(
            Actions.showSignInModal({
                isOpen: true,
                email,
                isOrderConfirmation: true,
                extraParams: {
                    orderId,
                    ...(points > 0 && { potentialBiPoints: points })
                }
            })
        );
    };

    const handleClick = () => {
        fireCtaLinkTracking();

        if (isEmailRegistered) {
            handleSignIn();
        } else {
            handleCreateAccount();
        }
    };

    const buttonText = getText(isEmailRegistered ? 'signIn' : 'createAccount');
    const messageText = getText(isEmailRegistered ? 'dontMissOutSignIn' : 'dontMissOut', [points]);

    return (
        <div>
            <Divider
                marginBottom={5}
                display={['block', 'none']}
            />
            <Markdown
                marginBottom={3}
                content={messageText}
            />
            <Button
                variant='primary'
                width={['100%', null, '200px']}
                onClick={handleClick}
            >
                {buttonText}
            </Button>
            <Divider marginY={5} />
        </div>
    );
};

export default wrapFunctionalComponent(GuestCheckoutJoinBI, 'GuestCheckoutJoinBI');
